import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import useApi from '../../hooks/useApi';


const StickerDelete = ({ event_id, sticker_id }) => {
	const { t } = useTranslation();
    const navigate = useNavigate();
    const [ type, setType ] = useState('unknown');
    const [ method, setMethod ] = useState('unknown');
    const [ data, error, isLoading ] = useApi({ type, method });

    useEffect(() => {
        if(data) navigate('/cabinet/eventview/' + event_id + '/action/updated');
    },[data, event_id, navigate]);

    const onClick = () => {
        if(!window.confirm(t('sticker.delete_confirm'))) {
			return;
		}
        setMethod('/stickers/' + sticker_id);
        setType('delete');
    };

    return (
    <div>
        {error ? <div>{t(error)}</div> :
        <React.Fragment>
            {isLoading ? <div>{t('common.loading')}</div> :
                <div className='a p' onClick={() => onClick()}>{t('sticker.delete')}</div>
            }
        </React.Fragment>
        }
    </div>
    );
};


StickerDelete.propTypes = {
    event_id: PropTypes.string.isRequired,
    sticker_id: PropTypes.string.isRequired,
};

export default StickerDelete;